import { gql } from '@apollo/client';

export const HOSPITAL_SYNCHRONIZATION_STATUS = gql`
subscription HospitalSynchronizationStatus($ids: [ID]) {
  hospitalSynchronizationStatus(ids: $ids) {
    hospitalIdentifier
    bedIdentifier
    visit
    isSynchronized
    generationBlocked
    status
    firstFailureAt
    blockedAt
    updatedAt
  }
}`;
